import React, { useEffect, useState, useRef } from 'react';
import { Grid, Paper, makeStyles, TextField, Typography, Button } from '@material-ui/core'
import { useDispatch, useSelector } from "react-redux";
import { ExitButton } from "../../utils/etc";
import { flightTextHistory, individualTextHistory } from "../../store/departures"
import { SelectWithLabel } from "../../utils/selectWithLabel";
import { textPax } from "../../store/departures";
import { Send} from '@material-ui/icons';
import moment from 'moment';
import _ from 'lodash';

let screenWidth = window.innerWidth

const useStyles = makeStyles((theme) => ({
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
    },
    closeFlightPaper: {
      position: 'absolute',
      top: '35%',
      width: screenWidth < 900 ? '80%' : '40%',
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
    },
    closeFlightSendingPaper: {
      position: 'absolute',
      top: '35%',
      width: '12%',
      height: '10%',
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: '2px 4px 2px 4px'
    },
    modalHeader: {
      fontSize: '40px',
      height: '20%',
      borderBottom: '2px solid rgba(201, 195, 195, 1)',
      backgroundColor: 'rgb(63, 81, 181, 1)'
    },
    editRow: {
      paddingTop: '8px',
      paddingBottom: '8px',
      backgroundColor: '#ede8e8'
    },
    // NOTE // combined editPax/movePax/textHist paper. (was 90:50 / 80:50 / 90:40 for width in the same order)
    paper: {
      position: 'absolute',
      width: screenWidth < 900 ? '90%' : '50%',
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
    },
    editPaxSendingPaper: {
      position: 'absolute',
      width: screenWidth < 900 ? '60%' : '15%',
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      marginTop: '12%',
      padding: '2px 4px 2px 4px'
    },
    sendTextStatusPaper: {
      position: 'absolute',
      width: screenWidth < 900 ? '70%' : '20%',
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      marginTop: '45vh',
      padding: '2px 4px 2px 4px'
    },
    accordionButton: {
      width: '100%',
      border: '1px solid black',
      backgroundColor: '#bbbbbb',
      cursor: 'pointer',
      position: 'relative'
    },
    instructionText: {
      fontWeight: 'bold',
      borderRadius: '15px',
      backgroundColor: '#cee7fd',
      paddingLeft: '3px',
      paddingRight: '3px',
      marginBottom: '8px'
    },
    arrowIcons: {
      position: 'absolute',
      top: '23%',
      left: '93%'
    },
    paperBasic: {
      position: 'absolute',
      width: 800,
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    bg0: {
      backgroundColor: 'gainsboro'
    },
    bg1: {
      backgroundColor: 'white'
    },
    center: {
      justifyContent: 'center',
      display: 'flex'
    },
    // TODO // change these to inline or more specific names
    header: {
      fontWeight: 'bold'
    },
    padding: {
      paddingLeft: '5px'
    },
    outboundPadding: {
      paddingRight: '5%'
    },
    inboundPadding: {
      paddingLeft: '5%'
    },
    outbound: {
      backgroundColor: '#005fff',
      color: 'white',
      marginTop: '10px',
      marginBottom: '10px',
      borderRadius: '25px',
      paddingLeft: '10px',
      paddingRight: '10px'
    },
    inbound: {
      backgroundColor: '#e3e3e3',
      marginTop: '10px',
      marginBottom: '10px',
      borderRadius: '25px',
      paddingLeft: '10px',
      paddingRight: '10px'
  
    },
    outboundMessageTimes: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      paddingRight: '10px'
    },
    inboundMessageTimes: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      paddingLeft: '10px'
    },
    centerDates: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-end'
    },
    messageContainer: {
      maxHeight: '50vh',
      overflow: 'auto'
    },
    absoluteCenter: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    textHistTextField: {
      margin: '12px 12px',
      border: 'black solid 1px'
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    movePaxButton: {
      height: '80%'
    }
}));

const TextHistoryModal = (props) => {
  const modalClasses = useStyles()
  const flight = props.flight
  const passengers = props.paxInfo && props.paxInfo.passengers ? props.paxInfo.passengers : []  
  const flightNum = `AN${props.paxInfo.flightStatus.flightNumber}`
  const closeModal = props.closeModal
  const date = useSelector(state => state.entities.departures.departureDate);
  const history = useSelector(state => state.entities.departures.history)
  const textSent = useSelector(state => state.entities.departures.sendText)
  const textResult = useSelector(state => state.entities.departures.textResults)
  const [paxList, setpaxList] = useState('default')
  const [message, setMessage] = useState('')
  
  let passengerChoices = []
  let formattedPassengerChoices = []
  if (passengers.length) {
    // NOTE // information being sent to api/texting
    passengerChoices = passengers && passengers.length ? passengers.map(p => {
      let firstName = p.profile.firstName
      let lastName = p.profile.lastName
      let formattedFirstName = firstName ? firstName[0] + firstName.slice(1, firstName.length).toLowerCase() : ''
      let formattedLastName = lastName ? lastName[0] + lastName.slice(1, lastName.length).toLowerCase() : ''
      let rloc = p.reservation.locator
      let phone = p.reservation.bookingInformation.contactInformation.phoneNumber
      if (firstName && lastName && rloc && phone) {
        let label = `${formattedFirstName} ${formattedLastName} (${rloc})`
        let value = {name: `${firstName} ${lastName}`, phone: phone, rloc: rloc}
        if (label && value) {          
          return {value: value, label: label}
        }
      }
    }).filter(n => n) : ['']
    // NOTE // for value to be read in SelectWithLabel value can't be an object
    // NOTE // adding in the 'All' option here so it isn't considered a passenger
    formattedPassengerChoices = passengerChoices.map(p => {return {label: p.label, value: JSON.stringify(p.value)}});
    formattedPassengerChoices.unshift({label: 'All History', value: 'default'})
  }

  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(flightTextHistory(date, flightNum))
  }, []);

  
  // NOTE Used for scrolling to bottom of chat window (showing newest messages first)
  const messagesEndRef = useRef(null)
  const scrollToBottom = () => {
    if (!messagesEndRef.current) return;
    messagesEndRef.current.scrollIntoView({ behavior: "smooth" })
  }
  useEffect(() => {
    scrollToBottom()
  }, [history]);


  const handlePaxList = (data) => {        
    if (data === 'default') {
      dispatch(flightTextHistory(date, flightNum))      
      setpaxList('default');
    } else {
      dispatch(individualTextHistory(JSON.parse(data).phone))
      setpaxList(data)
    }    
  }

  useEffect(() => {    
    if (textResult === 'success') {
      if (paxList === 'default') {
        dispatch(flightTextHistory(date, flightNum))      
        setpaxList('default');
        setMessage('');
      } else {
        dispatch(individualTextHistory(JSON.parse(paxList).phone))
        setpaxList(paxList)
        setMessage('');
      }        
    }
  },[textResult])

  

  const handleSend = () => {
    let passengerDetails;
    
    if (paxList !== 'default' && message) {
      let pax = JSON.parse(paxList);
      // NOTE // removing xml reserved characters
      // let formattedMsg = _.cloneDeep(message).split(',').join('').split('<').join('').split('>').join('').split('&').join('').split('\'').join('').split('\"').join('')
      passengerDetails = passengerChoices.find(pc => pc.value.phone === pax.phone)
      console.log('single pax: ', [passengerDetails.value])
      if (passengerDetails) {
        dispatch(textPax(message, flightNum, passengerDetails.value, date))        
      }
    }
  }
  
  let dateChecker = {};

  return (
    <Grid container justify="center" alignContent="center" style={{marginTop: '10%'}}>
      <Paper className={modalClasses.paper}>
        <Grid id="history-modal-header" container item xs={12} justify="center" className={modalClasses.modalHeader}>
          <Grid item xs={2} lg={2}></Grid>
          <Grid container justifyContent="center" item xs={8} lg={8}>
            <h5 style={{margin: "0px", paddingTop: "12px"}}>
              {`${flightNum} SMS History`}
            </h5>
          </Grid>
          <Grid item xs={1} lg={1}></Grid>
          <Grid container alignContent="flex-start" justifyContent="flex-end" style={{paddingRight: '8px'}} item xs={1}>
            <ExitButton exit={closeModal} />
          </Grid>
        </Grid>
        <Grid id="history-body" justifyContent="center" container item xs={12}>
          <Grid item xs={12} className={modalClasses.center}>
            <SelectWithLabel defaultVal={paxList} handleChange={(e) => {handlePaxList(e.target.value)}} inputLabel={'Passengers'} items={formattedPassengerChoices} customStyle={{width: '33%'}}/>
          </Grid>
          <Grid container className={modalClasses.messageContainer}>
            {!!history.length ? history.map((item) => {
              // NOTE // Used to display text messages sent / received on different days
              let newestDate = moment(new Date(item.timestamp)).format('DD MMM YYYY');
              !dateChecker[newestDate] ? dateChecker[newestDate] = 1 : dateChecker[newestDate]++;
              return (<Grid container justifyContent="center"> 
                {item.outbound ? 
                  <Grid container>
                    <Grid item xs={12} className={modalClasses.centerDates}><Typography>{dateChecker[newestDate] === 1 ? newestDate : ``}</Typography></Grid>
                    <Grid item xs={4} className={modalClasses.outboundMessageTimes}><Typography>{moment(item.timestamp).format('h:mmA')}</Typography></Grid>
                    <Grid item xs={8} className={modalClasses.outboundPadding}>
                      <Typography className={modalClasses.outbound}>{item.body}</Typography>
                    </Grid>
                  </Grid> : 
                  <Grid container>
                    <Grid item xs={12} className={modalClasses.centerDates}><Typography>{dateChecker[newestDate] === 1 ? newestDate : ``}</Typography></Grid>
                    <Grid item xs={8} className={modalClasses.inboundPadding}>
                      <Typography className={modalClasses.inbound}>{item.body}</Typography>
                    </Grid>
                    <Grid item xs={4} className={modalClasses.inboundMessageTimes}><Typography>{moment(item.timestamp).format('h:mmA')}</Typography></Grid>
                  </Grid>
                }
                <div ref={messagesEndRef} />
              </Grid>)
            }) : ``}
          </Grid>
          <Grid container>
            <Grid item xs={12} className={modalClasses.absoluteCenter} >
              {/* FIXME which textField?? */}
              <TextField 
                label="Message"
                multiline
                rows={3}
                className={modalClasses.textHistTextField}
                value={message}
                onChange={(e) => {setMessage(e.target.value)}}
                variant="filled"
                style={{width: '100%', height: 'inherit'}}
              />
            </Grid>
            <Grid item xs={12} className={modalClasses.outboundMessageTimes}> 
              {/* className={classes.button} */}
              {textResult === null || textResult === 'success'? 
                message.length  && paxList !== 'default' ? 
                <Button onClick={() => {handleSend()}} variant="contained" color="primary" endIcon={<Send />}>Send</Button> : 
                <Button disabled variant="contained" color="primary" endIcon={<Send />}>Send</Button> : 
              <Button disabled>Sending...</Button>
              }
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  )
};

export default TextHistoryModal;